// #region imports
import React, {useState} from 'react';
import { Colors, Spacing } from '_styles';
// #endregion

const CommentModal = ({ comment, setComment, onClose, onSubmit, product }) => {
    
    const [input, setInput] = useState(comment || '');
    
    return (
        <div style={styles.container}>

            {/* Product Title */}
            <h5 style={styles.title}>{product?.productTitle || "Product"}</h5>

            {/* Add comment textbox */}
            <textarea
                placeholder="Add a comment..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                style={{
                    ...styles.textarea,
                    //border: isFocused ? '2px solidrgb(64, 67, 246)' : '1px solid #5255eb',
                    outline: 'none',
                }}
                maxLength={50} // Limit to 200 characters
            />

            {/* save comment */}
            <button
                onClick={() => {
                    setComment(input.trim());
                    onSubmit(input.trim());
                    onClose();
                }}
                style={styles.button}
            >
                Done
            </button>
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: '#fff',
        padding: Spacing.SCALE_16,
        borderRadius: Spacing.SCALE_12,
        width: '90%',
        maxWidth: Spacing.SCALE_500,
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        zIndex: 10002,
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: Spacing.SCALE_10,
    },
    textarea: {
        width: '100%',
        height: Spacing.SCALE_60,
        padding: Spacing.SCALE_8,
        fontSize: 18,
        borderRadius: Spacing.SCALE_8,
        marginBottom: Spacing.SCALE_12,
    },
    button: {
        backgroundColor: Colors.PRM_LIGHT_BLUE,
        color: '#fff',
        padding: Spacing.SCALE_10,
        border: 'none',
        borderRadius: Spacing.SCALE_6,
        fontWeight: 'bold',
        fontSize: 14,
        display: 'block',
        margin: '0 auto',
        width: Spacing.SCALE_100
    }
};

export default CommentModal;
